import { FC } from 'react';

import { DATA_SOURCE } from 'utils/types';
import BaseCustomFieldsForm from 'modules/account/contact/forms/BaseCustomFieldsForm';

const DealCustomFieldsForm: FC = () => (
  <BaseCustomFieldsForm source={DATA_SOURCE.DEAL} />
);
export default DealCustomFieldsForm;
